import { render, staticRenderFns } from "./InformationPanel.vue?vue&type=template&id=450f8dad&scoped=true&"
import script from "./InformationPanel.vue?vue&type=script&lang=js&"
export * from "./InformationPanel.vue?vue&type=script&lang=js&"
import style0 from "./InformationPanel.vue?vue&type=style&index=0&id=450f8dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f8dad",
  null
  
)

export default component.exports